module.exports = __webpack_public_path__ + "static/media/platform_marketplace.7ca8227f.webp";